// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/en/imprint/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const imprintEN: PageEntry = {
  id: "post.impressum",
  locale: "en",
  slug: "imprint",
  seo: {
    navLabel: "Imprint",
    title: "Imprint | Dietz GmbH",
    description: "Imprint",
  },
  type: "post",
  h1: "Imprint",
  blocks: [
    { kind: "heading", level: 2, text: "Imprint" },
    { kind: "heading", level: 2, text: "Information according to § 5 TMG" },
    { kind: "paragraph", text: "Dietz GmbH Am Floßgraben 10 96465 Neustadt" },
    { kind: "paragraph", text: "Commercial Register: HRB 1008 Court of Registration: District Court of Coburg" },
    { kind: "paragraph", text: "Represented by: Manager: Dipl.-Wirtsch.-Ing. Matthias Dietz" },
    { kind: "heading", level: 2, text: "Contact" },
    { kind: "paragraph", text: "Phone: +49 (0) 9568 9442-0 Fax: +49 (0) 9568 9442-22 E-mail: info@dietz.eu" },
    { kind: "heading", level: 2, text: "Mailing address" },
    { kind: "paragraph", text: "P.O. Box 1170 96456 Neustadt" },
    { kind: "heading", level: 2, text: "VAT ID" },
    { kind: "paragraph", text: "Sales tax identification number according to § 27 a of the Value Added Tax Act: DE 132406443" },
    { kind: "heading", level: 2, text: "EU Dispute Settlement" },
    { kind: "paragraph", text: "The European Commission provides a platform for online dispute resolution (ODR): https://ec.europa.eu/consumers/odr/ . Our e-mail address can be found at the top of the imprint." },
    { kind: "heading", level: 2, text: "Consumer Dispute Resolution/Universal Arbitration Board" },
    { kind: "paragraph", text: "We are not willing or obliged to participate in dispute resolution proceedings before a consumer arbitration board." }
  ],
};
